import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TRANSLATIONS from 'components/twilio/translations';
import styled from 'styled-components';
import { COLORS } from '../constants';

const UnreadIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 8px 0;
  &:before, &:after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${COLORS.GREY_H};
  }
`;

const UnreadText = styled.div`
  padding: 4px 12px;
  border-radius: 30px;
  border: 1px solid ${COLORS.GREY_H};
  background: ${COLORS.GREY_S};
  color: ${COLORS.TEXT_DARK};
  text-transform: uppercase;
  font-size: 14px;
`;

export interface UnreadIndicatorProps {
  unreadCount: number;
}

const UnreadIndicator: FC<UnreadIndicatorProps> = ({ unreadCount }) => {
  const { t } = useTranslation();

  return (
    <UnreadIndicatorContainer>
      <UnreadText>
        {t(
          TRANSLATIONS.COMMON.UNREAD[0],
          `${unreadCount} unread message(s)`,
          { unreadCount },
        )}
      </UnreadText>
    </UnreadIndicatorContainer>
  );
};

export default UnreadIndicator;
